import Bag from '@phoenix/components/Bag';
import SizeSelector from '@phoenix/components/SizeSelector';
import FindInBoutique from '@phoenix/components/FindInBoutique';

Object.assign(window, {
  Bag,
  SizeSelector,
  FindInBoutique,
});
